import {
  DeliveryDefaultCityModel,
  DeliveryIntervalsPerDateModel,
  DeliveryRouteDeliveryV2Model,
} from '../../api/data-contracts';

export interface DeliveryIntervalsPerDateModelWithVersion extends DeliveryIntervalsPerDateModel {
  date: string;
  version: CourierIntervalsVersion;
}

export interface DeliveryRouteDeliveryModelWithVersion extends DeliveryRouteDeliveryV2Model {
  intervalsPerDate?: DeliveryIntervalsPerDateModelWithVersion[];
}

export type JoinedRoutesResponse = {
  defaultCity: Partial<DeliveryDefaultCityModel> & { isSelfRegistrationOnly?: boolean };
  intervalsByDate: Record<
    DeliveryIntervalsPerDateModelWithVersion['date'],
    DeliveryIntervalsPerDateModelWithVersion
  >;
  intervalsPerDate: DeliveryIntervalsPerDateModel[];
};

export enum CourierIntervalsVersion {
  v1 = 1,
  v2,
}
